module.exports = fox._r("images/logos/img-4.png", __webpack_public_path__ + "_/_/_/common/frame/images/logos/img-4.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos/img-4.png
// module id = 319
// module chunks = 2